"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { FileCheck, ArrowRight, ShieldCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Action() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="llamado-a-la-acción" data-nav="dark" className="dark bg-background text-foreground relative overflow-hidden py-20 lg:py-28 border-t border-b border-ring/25">
      {/* Subtle architectural background accents */}
      <div className="absolute inset-0 pointer-events-none opacity-5">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-full border-x border-ring" />
      </div>

      <div className="relative mx-auto max-w-5xl px-6 md:px-10 lg:px-16 text-center">
        {/* Eyebrow badge */}
        <motion.div initial={shouldReduceMotion ? false : {
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        ease: [0.16, 1, 0.3, 1]
      }} className="inline-flex items-center gap-2 px-3 py-1 mb-6 rounded-xs border border-ring/40 bg-ring/10">
          <ShieldCheck className="w-3.5 h-3.5 text-ring" />
          <span className="font-serif text-xs font-bold tracking-widest uppercase text-ring">
            Acompañamiento en licitaciones
          </span>
        </motion.div>

        {/* Centered headline */}
        <motion.h2 initial={shouldReduceMotion ? false : {
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        delay: 0.08,
        ease: [0.16, 1, 0.3, 1]
      }} className="font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-wide text-foreground uppercase leading-tight max-w-3xl mx-auto">
          Asegure la solvencia técnica y legal de sus propuestas
        </motion.h2>

        {/* ASV Gold Hairline divider */}
        <motion.div initial={shouldReduceMotion ? false : {
        scaleX: 0
      }} whileInView={{
        scaleX: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.16,
        ease: [0.25, 1, 0.5, 1]
      }} className="w-12 h-[1.5px] bg-ring mx-auto my-6 origin-center" />

        {/* Supporting copy */}
        <motion.p initial={shouldReduceMotion ? false : {
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        delay: 0.22,
        ease: [0.16, 1, 0.3, 1]
      }} className="font-sans text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
          Revisamos minuciosamente bases, anexos técnicos y documentación legal para proveedores y contratistas del sector público, eliminando causales de descalificación.
        </motion.p>

        {/* Trust Indicators */}
        <motion.div initial={shouldReduceMotion ? false : {
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        delay: 0.3,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-wrap items-center justify-center gap-6 text-xs text-muted-foreground my-8 font-sans">
          <div className="flex items-center gap-2">
            <FileCheck className="w-4 h-4 text-ring" />
            <span>Auditoría de expedientes técnicos</span>
          </div>
          <span className="text-ring/40 hidden sm:inline">•</span>
          <div className="flex items-center gap-2">
            <FileCheck className="w-4 h-4 text-ring" />
            <span>Cumplimiento normativo estricto</span>
          </div>
          <span className="text-ring/40 hidden sm:inline">•</span>
          <div className="flex items-center gap-2">
            <FileCheck className="w-4 h-4 text-ring" />
            <span>Respaldo de consultores senior</span>
          </div>
        </motion.div>

        {/* Action button */}
        <motion.div initial={shouldReduceMotion ? false : {
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        delay: 0.36,
        ease: [0.16, 1, 0.3, 1]
      }} className="pt-2 flex justify-center">
          <Button asChild className="h-12 px-8 rounded-xs font-serif text-sm font-semibold tracking-wider uppercase border border-ring bg-primary text-primary-foreground transition-colors hover:bg-ring hover:text-foreground">
            <Link to="/ContactPage" className="inline-flex items-center gap-3">
              <span>Solicitar cotización</span>
              <ArrowRight className="w-4 h-4" />
            </Link>
          </Button>
        </motion.div>
      </div>
    </section>;
}